(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_cb44666"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var btn = document.querySelector('.ai-vip-warroom-primary-btn-{{ ai_gen_id }}');
    if (!btn) return;

    btn.addEventListener('click', function(event) {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return; // fallback to normal link if no variant

      event.preventDefault();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // After adding to cart, send them to cart (or change to /checkout if you want)
        window.location.href = '/cart';
      })
      .catch(function(error) {
        console.error('Error adding VIP Membership to cart:', error);
        // If something breaks, just go to the product page as backup
        window.location.href = '{{ vip_product.url | default: "/products/vip-club-membership" }}';
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
